import { isUndefined } from 'lodash';
import { Loader } from 'components/Loader';
import { AssignmentFeedback } from 'domains/assignments/types';
import { CustomStructuredActivityUI } from 'domains/customStructuredActivities/Page/ui';
import { CustomStructuredActivityCtx } from 'domains/customStructuredActivities/context';
import { STRUCTURED_ACTIVITY_STEPPER_TITLES } from 'domains/structuredActivities/steps';
import { useCompletableWizard } from 'utils/hooks/useCompletableWizard';
import { useCustomStructuredActivity } from 'domains/customStructuredActivities/queries';

type Props = {
  structuredActivityId: string;
  onSubmit: (feedback: AssignmentFeedback) => void;

  previewMode?: boolean;
};

export const CustomStructuredActivity: React.FC<Props> = ({ structuredActivityId, onSubmit, previewMode = false }) => {
  const { data: content, error, isLoading: isLoadingContent } = useCustomStructuredActivity(structuredActivityId);

  const wizard = useCompletableWizard(Object.keys(STRUCTURED_ACTIVITY_STEPPER_TITLES).length);

  if (isLoadingContent) {
    return <Loader defaultStyles />;
  }

  if (isUndefined(content)) {
    throw new Error(`Failed to fetch data for ADL ID: ${structuredActivityId}. Error was ${error}`);
  }

  return (
    <CustomStructuredActivityCtx.Provider
      value={{
        ...wizard,
        previewMode,
        structuredActivityContent: content,
        onComplete: onSubmit,
      }}
    >
      <CustomStructuredActivityUI />
    </CustomStructuredActivityCtx.Provider>
  );
};

export default CustomStructuredActivity;
